<template>
  <header class="mx-auto">
    <div align="left">
      <img style="margin:0px;height:70px" v-if="hasCompanyLogo" :src="companyLogo">
      <img style="margin:0px;height:70px" v-else-if="hasSiteCompanyLogo" :src="siteCompanyLogo">
      <img style="margin:20px;height:30px" v-else src="../assets/images/psytest_logo.png">
    </div>
    <nav class="navbar bg-secondary">
      <ul class="nav nav-fill">
        <li class="nav-item active">
          <router-link to="/">{{ $t('publicPage.menu') }}</router-link>
        </li>
        <li class="nav-item">
          <b-link :href="testPage" target="_blank">{{ $t('testPage.menu') }}</b-link>
        </li>
        <li v-if="isAuthenticated" class="nav-item">
          <router-link to="/private">{{ $t('privatePage.menu') }}</router-link>
        </li>
      </ul>
      <div v-if="isAuthenticated">
        <b-link v-on:click="logout">{{ $t('privatePage.menu_logout') }}</b-link>
      </div>
      <div v-else>
        <router-link to="/private">{{ $t('privatePage.menu_login') }}</router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'app-header',
  methods: {
    ...mapActions({
      logout: 'logout'
    })
  },
  computed: {
    ...mapGetters('userGroupsModule', ['userCompany']),
    ...mapGetters(['isAuthenticated', 'siteCompanyLogo', 'settings']),
    hasCompanyLogo: function() {
      return (
        this.userCompany &&
        this.userCompany.imageUrl &&
        this.userCompany.imageUrl !== undefined &&
        this.userCompany.imageUrl.length > 0
      )
    },
    hasSiteCompanyLogo: function() {
      return (
        this.siteCompanyLogo &&
        this.siteCompanyLogo !== undefined &&
        this.siteCompanyLogo.length > 0
      )
    },
    companyLogo: function() {
      return this.hasCompanyLogo ? this.userCompany.imageUrl : ''
    },
    testPage: function() {
      return this.settings ? this.settings.path_UserTest : ''
    }
  }
}
</script>

<style scoped>
header {
  text-align: left;
  text-align: center;
}

header li {
  padding-left: 5px;
  padding-right: 5px;
}

a,
a:visited {
  font-weight: bolder;
  color: white;
  text-decoration: none;
}
a:hover {
  color: white;
  text-decoration: underline;
}
</style>
